/* eslint-disable */
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import genererContrat from '@/services/baux/contrat/genererContrat';
import { LISTE_TYPE_CONTRAT, LISTE_TERME_PAIEMENT,
  LISTE_ETAT_CONTRAT, MOIS, ANNEE, TERME_PAIEMENT_AVANCE } from '@/configuration/baux/contrat/contratConf';
import i18n from '@/i18n';
import formatDate from '@/services/general/formatIsoDate';
import moment from 'moment';
import calculArrondi from '@/services/calcul/calculArrondi';
import genererIntervenants from '@/services/import/bail/generation/genererLienBailBailleurs';
import genererMaterielsContrat from '@/services/import/bail/generation/genererLienBailMateriels';
import genererEcheancierBail from '@/services/import/bail/generation/genererEcheancierBail';
import booleanConverter from '@/services/import/General/booleanConverter';
import { syncAddMateriel } from '@/services/baux/contrat/syncMaterielProduitId'

function getPeriodicite(bail, periode) {
  if (periode === 'Trimestrielle') {
    bail.unitePeriodicite = MOIS;
    bail.quantitePeriodicite = 3;
  }
  if (periode === 'Semestrielle') {
    bail.unitePeriodicite = MOIS;
    bail.quantitePeriodicite = 6;
  }
  if (periode === 'Annuelle') {
    bail.unitePeriodicite = ANNEE;
    bail.quantitePeriodicite = 1;
  }
  if (periode === 'Mensuelle') {
    bail.unitePeriodicite = MOIS;
    bail.quantitePeriodicite = 1;
  }
}

export default async function genererBail(ligne, bailleursOfBail, materielsOfBail, informationApiReference) {
  const contratNatureFind = store.getters['parametres/parametre'](PARAMETRES_KEYS.contratNature)
            .find((contratNature) => {
              return contratNature.libelle.toLowerCase().trim() === ligne.natureBail.toLowerCase().trim();
            });
  const bail = genererContrat(contratNatureFind ? contratNatureFind.id : null);
  bail.code = ligne.codeBail.trim();
  const typeBailFind = LISTE_TYPE_CONTRAT.find((type) => {
    return i18n.t(type.libelle).toLowerCase().trim() === ligne.typeBail.toLowerCase().trim();
  });
  bail.type = typeBailFind ? typeBailFind.code : LISTE_TYPE_CONTRAT[0].code;
  bail.commentaire = ligne.commentaire ?? '';
  if (typeof ligne.montantAnnuelHT === 'string') {
    const newMontantAnnuel = ligne.montantAnnuelHT.replace(',', '.').replace(/[^\d.]/g, '');
    bail.loyerAnnuelHt = parseFloat(newMontantAnnuel);
  } else bail.loyerAnnuelHt = ligne.montantAnnuelHT ? calculArrondi(ligne.montantAnnuelHT) : 0;

  let newTauxTva = 0;
  if (ligne.tauxTva && (ligne.tauxTva.includes('%'))) newTauxTva = ligne.tauxTva.replace(',', '.').replace('%', '');
  newTauxTva = parseFloat(newTauxTva);
  bail.tauxTva = newTauxTva;

  bail.loyerAnnuelTtc = calculArrondi(bail.loyerAnnuelHt + (bail.loyerAnnuelHt * bail.tauxTva / 100));
  bail.loyerAnnuelTva = calculArrondi(bail.loyerAnnuelTtc - bail.loyerAnnuelHt);
  bail.societeId = store.getters['societe/societeActiveId'];
  bail.dateDebutSignature = ligne.dateDebutBail ? formatDate(moment(ligne.dateDebutBail, 'DD/MM/YYYY')) : null;
  bail.dateFinSignature = ligne.dateFinBail ? formatDate(moment(ligne.dateFinBail, 'DD/MM/YYYY')) : null;
  bail.dateSignature = ligne.dateSignature ? formatDate(moment(ligne.dateSignature, 'DD/MM/YYYY')) : null;
  if (ligne.datePreavis) {
    bail.datePreavis = ligne.datePreavis ? formatDate(moment(ligne.datePreavis, 'DD/MM/YYYY')) : null;
  } else {
    const date = moment(bail.dateFinSignature).subtract(3, 'months').toDate();
    bail.datePreavis = formatDate(moment(date, 'DD/MM/YYYY'));
  }
  bail.nbAn = ligne.dureeBailEnAnnee;
  bail.dateDebutEcheance = ligne.dateDebutEcheancier ? formatDate(moment(ligne.dateDebutEcheancier, 'DD/MM/YYYY')) : null;
  bail.dateFinEcheance = ligne.dateFinEcheancier ? formatDate(moment(ligne.dateFinEcheancier, 'DD/MM/YYYY')) : null;
  bail.dateFinPremiereEcheance = ligne.dateFinPremiereEcheance ? formatDate(moment(ligne.dateFinPremiereEcheance, 'DD/MM/YYYY')) : null;
  bail.termePaiement = ligne.termePaiement ? LISTE_TERME_PAIEMENT.find((type) => {
    return i18n.t(type.libelle).toLowerCase() === ligne.termePaiement.toLowerCase();
  }).code : TERME_PAIEMENT_AVANCE;

  bail.reconductible = booleanConverter(ligne.reconductibleTacitement);
  const signataires = store.getters['parametres/parametre'](PARAMETRES_KEYS.contratSignataire);
  bail.signataireId = ligne.signataire ? signataires.find((signataire) => {
    return signataire.libelle.toLowerCase() === ligne.signataire.toLowerCase();
  }).id : null;
  bail.etat = ligne.etat ?  LISTE_ETAT_CONTRAT.find((type) => {
    return i18n.t(type.libelle).toLowerCase() === ligne.etat.toLowerCase();
  }).code : LISTE_ETAT_CONTRAT[0].code;

  getPeriodicite(bail, ligne.periocidite);
  if (bailleursOfBail.length) genererIntervenants(bail, bailleursOfBail, informationApiReference.bailleurs);
  if (materielsOfBail.length) {
      genererMaterielsContrat(bail, materielsOfBail, informationApiReference.materiels);
      await syncAddMateriel(bail);
  }
  if (bail.intervenants.every(i => i.modeReglementId)) bail.echeancier = await genererEcheancierBail(bail, ligne);
  const agences = store.getters['societe/agenceActive'];
  bail.agenceId = agences[0].agenceId;
  bail.numLigneImportDonne = ligne.numLigne;
  return bail;
}
